<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { mapGetters, mapMutations } from 'vuex';
import apiUrl from './static/backstageUrl';

export default {
  name: 'App',
  data() {
    return {
      duration: 1500,
    };
  },
  methods: {
    ...mapMutations(['change_token', 'change_curPath', 'change_user']),
    getUserDetail(curPath) {
      Toast.loading({
        mask: true,
        message: '加载中...'
      });

      // 记录当前路径
      this.change_curPath(curPath);
      this.$http.post(`${this.URL_PREFIX}/app/get/user/info/detail/wx`, {
        redirectUri: `${this.URL_PREFIX_PAGE}/auth/authorizeCb`,
      }).then((response) => {
        const res = response.data;
        console.log(res.resData);
        if (res.resCode === '10000') {
          this.change_user(res.resData);
        } else if (res.resCode === '20201') {
          // const uri = res.resData.redirectUri;
          console.log("redirectUri路径"+res.resData.redirectUri)
          window.location.href = apiUrl.wxLoginUrl || res.resData.redirectUri;
        } else {
          Toast.fail({ duration: this.duration, message: res.resDesc });
        }
      });
    },
  },
  created() {
    //登录
    this.$root.eventHub.$on('login', (curPath) => {
      this.getUserDetail(curPath);
    });
  },
};
</script>

<style>
#app {
  min-height: 100%;
  background-color: #fff;
}
</style>




// WEBPACK FOOTER //
// src/App.vue